import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

const Contact = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "center center"] });
  const rotateX = useTransform(scrollYProgress, [0, 1], [70, 0]);
  const scale = useTransform(scrollYProgress, [0, 1], [0.7, 1]);
  const opacity = useTransform(scrollYProgress, [0, 0.6], [0, 1]);

  return (
    <section id="contact" className="contact" ref={ref}>
      <div className="contact-glow" />
      <motion.div className="contact-inner" style={{ rotateX, scale, opacity }}>
        <span className="eyebrow">
          <span className="dot" /> Contact
        </span>
        <h2 className="contact-title">
          Let's ship
          <br />
          <span className="accent">the next one.</span>
        </h2>
        <p className="contact-sub">
          Partnerships, publishing, press or just a hello — we read everything.
        </p>
        <a href="mailto:app@meck-int.com" className="contact-mail">
          app@meck-int.com <span aria-hidden="true">↗</span>
        </a>
      </motion.div>
    </section>
  );
};

export default Contact;
